export default function getButtonBackgroundColor({ buttonBackgroundColor, brandColor }) {
  if (buttonBackgroundColor) {
    return buttonBackgroundColor;
  }

  if (brandColor) {
    return brandColor;
  }

  return '#000000';
}
